<template>
  <div>
    <custom-popup
      v-model="showDialogIdea"
      :cons="constIdea"
      :loading="false"
      max-width="600"
      hideConfirm
      transition="dialog-bottom-transition"
    >
      <v-card class="px-5">
        <v-row class="mt-4">
          <v-col cols="12" md="8" class="ma-5 d-flex justify-center">
            <v-text-field
              v-model="promptIdea"
              class="rounded-lg"
              dense
              :rules="[rules.empty, rules.spellChecker]"
              label="موضوع ساخت کیو آر"
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2" class="my-5 d-flex justify-center">
            <v-btn
              :class="[isPromptValid ? 'btn-get-code' : 'btn-edit']"
              class="btn px-4"
              @click="genetateTextForIdea(promptIdea, false)"
              :disabled="!isPromptValid"
            >
              <v-icon>{{
                isPromptValid ? "mdi-lightbulb-on" : "mdi-lightbulb-off"
              }}</v-icon>
              تایید ایده کیو آر من
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </custom-popup>
    <custom-popup
      v-model="showDialog"
      :cons="cons"
      hide-confirminfo
      max-width="900"
      transition="dialog-bottom-transition"
    >
      <v-card class="px-5">
        <download-file
          v-if="showDialog"
          :data="{ theme: '', data: cardTexts }"
          :svg="svgMade"
          :visit-name="cardTexts.visitName"
        />
      </v-card>
    </custom-popup>

    <div class="p-5 w-100">
      <v-card :loading="loading" class="p-5 w-100" flat>
        <v-row class="pb-0 pt-4 w-100">
          <v-col cols="12" md="4" class="cover">
            <!-- <qr-maker
                :loading="loading"
                class="sticky-md"
                style="top: 110px"
                                v-if="pngimg !== '' && !!pngimg"

              /> -->
            <div class="pa-2">
              <v-card-subtitle
                class="pa-0 pa-3 mb-3 text-center"
                style="border-radius: 8px"
                v-if="pngimg !== '' && !!pngimg"
                :style="
                  scannable && pngimg !== ''
                    ? 'background-color: rgb(165, 240, 215);'
                    : isplaceholder
                    ? 'background-color: rgb(160, 190, 211);'
                    : 'background-color: rgb(248, 169, 169);'
                "
              >
                <v-icon
                  small
                  left
                  :color="
                    scannable && pngimg !== ''
                      ? 'green'
                      : isplaceholder
                      ? 'blue'
                      : 'red'
                  "
                >
                  {{
                    scannable
                      ? "mdi-check-circle"
                      : isplaceholder
                      ? "mdi-information-outline"
                      : "mdi-close-circle"
                  }}
                </v-icon>
                <span
                  :class="
                    scannable && pngimg !== ''
                      ? 'text-success'
                      : isplaceholder
                      ? 'text-white'
                      : 'text-error'
                  "
                >
                  {{
                    scannable && pngimg !== ""
                      ? "قابل اسکن است"
                      : isplaceholder
                      ? "نمونه ای از ساخت هوش مصنوعی..."
                      : `ممکن است در کلیه دستگاه‌ها اسکن نشود. 
                        در صورت عدم اسکن مجدد تلاش کنید.`
                  }}
                </span></v-card-subtitle
              >
              <v-img
                :src="pngimg"
                alt=""
                width="100%"
                :lazy-src="pngimg"
                aspect-ratio="1"
                class="cursor-pointer grey lighten-2"
                @click="showImg()"
                @load="onImageLoad"
                @error="onImageError"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      v-if="loading"
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
            <v-btn
              class="btn-download"
              @click="downloadurlImg(pngimg)"
              v-if="pngimg !== '' && !!pngimg"
            >
              <v-icon>mdi-progress-download</v-icon>
              دانلود کیوآر
            </v-btn>
          </v-col>
          <v-col cols="23" md="8">
            <!--          <qr-customize v-model="qrDesign" :loading="loading"/>-->
            <v-card class="pa-4" flat>
              <v-row no-gutters>
                <v-col cols="12" md="12">
                  <v-card-subtitle class="font-weight-bold">
                    شرح کیوآر مورد نظر خودرا وارد نمایید، تا هوش مصنوعی آن را
                    برای شما خلق کند.
                  </v-card-subtitle>
                </v-col>

                <v-col
                  class="pa-2 d-flex justify-space-between justify-md-start"
                  cols="12"
                  md="4"
                >
                  <div class="rowinfo">
                    <togetherAiUpgradeNew
                      v-model="showUpgrade"
                      :current-package.sync="currentPackage"
                      class="contentinfo"
                    />
                  </div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        class="rounded-lg me-2 info--text"
                        color="rgba(198, 198, 198, .3)"
                        small
                        v-bind="attrs"
                        @click="showUpgrade = true"
                        v-on="on"
                      >
                        <v-icon left small>mdi-creation-outline</v-icon>
                        <span v-if="computedCurrentPackage">{{
                          computedCurrentPackage.count || "0"
                        }}</span>
                      </v-chip>
                    </template>

                    <span v-if="computedCurrentPackage">
                      باقی مانده:
                      {{ persian(computedCurrentPackage.count) }} ساخت کیوآر
                      {{ computedCurrentPackage.free ? " - رایگان" : "" }}
                    </span>
                  </v-tooltip>

                  <v-menu offset-y open-on-hover>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="rounded-lg text-none"
                        depressed
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon left>mdi-chevron-down</v-icon>
                        {{ langItems[selectedLang].text }}
                        <v-icon right>mdi-web</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-subheader
                        >انتخاب زبان برای نوشتن متن درخواست</v-subheader
                      >
                      <v-list-item-group v-model="selectedLang" color="primary">
                        <v-list-item v-for="(item, i) in langItems" :key="i">
                          <v-list-item-icon class="py-1 me-2">
                            {{ item.flag }}
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              item.text
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <div class="rowinfo" style="width: 100%">
                <v-textarea
                  v-model="prompt"
                  :loading="loading"
                  :rules="[rules.empty, rules.max]"
                  class="rounded-lg contentinfo py-2 my-2 w-100 pp"
                  dense
                  clearable
                  label="متن درخواست"
                  outlined
                  placeholder="کیوآر لینک مورد نظر خودرا شرح دهید..."
                  @input="debounceTranslate"
                >
                  <template v-slot:append>
                    <v-btn
                      :color="strangthen ? 'orange' : 'success'"
                      :loading="loading_Ai"
                      depressed
                      @click="
                        strangthen && prompt.length > 0
                          ? genetateTextForIdea(prompt, strangthen)
                          : (showDialogIdea = true)
                      "
                    >
                      <v-icon v-if="strangthen" left>mdi-cog-refresh</v-icon>
                      <v-icon v-else left>mdi-lightbulb-on</v-icon>
                      {{ strangthen ? "تقویت متن موجود" : "ایده پرامپت " }}
                    </v-btn>
                  </template>
                </v-textarea>
                <v-text-field
                  dense
                  outlined
                  v-model="link"
                  label="لینک خود را وارد کنید"
                  :rules="[
                    (v) =>
                      isDomain(v) ||
                      !v ||
                      'لینک به صورت صحیح وارد نمایید (website.com)',
                  ]"
                />
              </div>
              <div class="rowinfo mt-0 mr-auto float-left justify-center">
                <v-btn
                  class="submit-btn"
                  :disabled="!isPromptTextareaValid"
                  :loading="loading"
                  depressed
                  @click="changeInput"
                >
                  <v-icon v-if="regenerate" left>mdi-reload</v-icon>
                  <v-icon v-else left>mdi-image-auto-adjust</v-icon>
                  {{
                    !isplaceholder &&
                    scannable === false &&
                    prompt?.trim() !== ""
                      ? "تلاش مجدد"
                      : "ساخت کیوآر"
                  }}
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

      <custom-popup
        v-model="mediaDialog"
        :cons="{ title: 'کیوآر کد هوشمند' }"
        width="720"
        hide-confirm
        class="popup"
      >
        <div class="cover-dialog">
          <div class="zoom-controls">
            <v-btn class="btnZoom" @click="zoomIn" icon>
              <v-icon>mdi-magnify-plus</v-icon>
            </v-btn>
            <v-btn class="btnZoom" @click="zoomOut" icon>
              <v-icon>mdi-magnify-minus</v-icon>
            </v-btn>
            <v-btn class="btnZoom" @click="resetZoom" icon>
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </div>
          <div class="text-center pa-4 conteiner-zoom">
            <v-img
              :src="pngimg"
              alt="ساخت کیوآر کد هوشمند"
              width="100%"
              height="100%"
              :lazy-src="pngimg"
              :style="imageStyle"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    v-if="loading"
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
        </div>
      </custom-popup>
    </div>
  </div>
</template>

<script>
import QrCustomize from "./components/qrCustomize.vue"; //
import QrMaker from "./components/qrMarker.vue"; //
import QrCodeMake from "./components/qrCodeMake.vue"; //
import axios from "axios"; //
import DownloadFile from "./components/DownloadFile.vue"; //
import { debounce } from "@/main"; //
import { saveOnCdnFiles } from "@/utilities/ImageGallery"; //
import SwiperWrapper from "../../../components/utilities/SwiperWrapper.vue"; //
import togetherAiUpgradeNew from "../../../components/image/togetherAiUpgradeNew.vue";
import placeholder from "./components/media/placeholder.png";
export default {
  name: "aiDesign",

  components: {
    DownloadFile,
    QrCodeMake,
    QrMaker,
    QrCustomize,
    SwiperWrapper,
    togetherAiUpgradeNew,
  },
  data() {
    return {
      promptIdea: "",
      InitialpromptIdea: "",
      constIdea: {
        title: "ایده ساخت کیو آر",
        // buttons: [
        //   {
        //     type: "submit",
        //     handler: (v) => this.genetateTextForIdea(v, false),
        //   },
        // ],
      },
      persianText: "",
      englishText: "",
      loading_Ai: false,
      isRoost: false,
      cons: { title: "دانلود کیوآر" },
      showDialog: false,
      scale: 1,
      flag: false,
      mediaDialog: false,
      start: false,
      serviceName: "Qrland",
      componentName: "ai-design",
      helpData: [],
      pngimg: placeholder,
      isplaceholder: true,
      scannable: false,
      qrDesign: null,
      qrSvgDataUrl: "",
      data: {},
      svg: "",
      prompt: "",
      promptIdea: "",
      showDialogIdea: false,
      iterativeMode: false,
      showUpgrade: false,
      currentPackage: {},
      loading: false,
      result: [],
      indexAt: -1,
      upLoading: false,
      catName: "کیوآر های ساخته شده",
      lastprompt: "",
      link: null,
      sizeModel: "1:1",
      sizeItems: [
        {
          value: "1:1",
          text: "1:1 (مربع)",
          width: 1024,
          height: 1024,
          icon: "square-outline",
        },
      ],
      translation: "",
      selectedLang: 0,
      isWriting: false,
      langItems: [
        { value: "fa", text: "Fa | فارسی", name: "فارسی", flag: "🇮🇷" },
        { value: "en", text: "En | انگلیسی", name: "انگلیسی", flag: "🇬🇧" },
      ],
      rules: {
        empty: (v) =>
          !!v || v?.trim()?.length >= 3 || "حداقل ۳ کاراکتر باید وارد شود!",
        spellChecker: (v) =>
          !!v ||
          this.spellChecker(v) ||
          `متن وارد شده باید به زبان ${this.computedSelectedLang.name} باشد!`,
        max: (value) =>
          (!!value && value.length >= 70) ||
          "متن درخواست باید بیش از  70 حرف باشد لطفا متن طولانی تری وارد کنید تا نتیجه مناسب را دریافت کنید.",
      },
    };
  },
  mounted() {
    this.getPackage(); // for
  },

  computed: {
    isPromptTextareaValid() {
      console.log(this.isDomain(this?.link));

      return (
        this.rules.empty(this.prompt) === true &&
        this.rules.max(this.prompt) === true &&
        this.rules.spellChecker(this.prompt) === true &&
        this.isDomain(this?.link)
      );
    },
    isPromptValid() {
      const reg = {
        en: /^[A-Za-z\s.,!?]*$/,
        fa: /^[\u0600-\u06FF\u06F0-\u06F9\s.,!?]*$/,
      };
      return (
        this.promptIdea?.trim().length >= 3 &&
        this.rules.spellChecker(this.promptIdea?.trim()) &&
        reg[this.computedSelectedLang.value].test(this.promptIdea?.trim())
      );
    },
    imageStyle() {
      return {
        transform: `scale(${this.scale})`,
        transition: "transform 0.3s ease-in-out",
        width: "800px",
        height: "auto",
      };
    },

    domainName() {
      return this.$route.params.name;
    },
    qrIdf() {
      return this.$route.params.id;
    },
    strangthen() {
      return (this.prompt?.trim() || "")?.split(" ")?.length > 3 || false;
    },
    regenerate() {
      let p =
        this.langItems[this.selectedLang].value === "fa"
          ? this.translation
          : this.prompt;
      return !!p && this.lastprompt?.trim() === p?.trim();
    },
    computedSelectedLang() {
      return this.langItems[this.selectedLang];
    },
    // allowGenerate() {
    //   return typeof this.rules.spellChecker(this.prompt) === "boolean";
    // },
    computedCurrentPackage() {
      let packages = this.currentPackage;

      return packages.remaining instanceof Array
        ? packages.remaining.reduce((obj, curr) => {
            obj.free = false;

            if (!obj.hasOwnProperty("count"))
              obj.count = Number(curr.remaining);
            else obj.count += Number(curr.remaining);

            return obj;
          }, {})
        : {
            free: packages.package_id === null,
            count: packages.remaining,
          };
    },
  },

  watch: {
    selectedLang(val) {
      this.prompt = "";
      this.translation = "";
    },
  },
  methods: {
    onImageError() {
      this.loading = false;
      this.$toast.error("خطا در بارگذاری تصویر!");
      // this.prompt = "";
    },

    isDomain(str) {
      let regex = new RegExp(
        "[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)",
        "ig"
      );

      return regex.test(str);
    },
    onImageLoad() {
      this.loading = false;
      // this.prompt = "";
    },
    showImg() {
      this.mediaDialog = true;
    },
    downloadurlImg(source) {
      // const filename = `image-.png`;

      // const link = document.createElement("a");
      // link.href = source;
      // link.download = filename;
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      if (source) {
        this.compressImageAndDownload(
          source,
          0.9,
          800,
          `qr_code-${Date.now()}.jpg`
        );
      }
    },

    autoSave(options) {
      this.qrDesign = options;
    },
    debounceTranslate() {
      this.isWriting = true;

      debounce(() => {
        let lang = this.langItems[this.selectedLang].value;

        if (lang === "fa") {
          //  this.translateprompt();
          this.isWriting = false;
        } else {
          this.isWriting = false;
        }
      }, 2000);
    },
    translateprompt(langfrom = "per", langto = "eng") {
      if (
        this.langItems[this.selectedLang].value === "fa" &&
        langfrom === "per" &&
        this.prompt.length >= 70
      ) {
        if (this.persianText?.trim() === (this.prompt?.trim() || "")) {
          this.translation = this.englishText?.trim();
          this.getImage();
        } else {
          this.loading = true;
          axios
            .post("https://api.reverso.net/translate/v1/translation", {
              format: "text",
              from: langfrom,
              to: langto,
              input: this.prompt.replace(/\n/g, " "),
              options: {
                sentenceSplitter: true,
                origin: this.$coreqrOrigin,
                contextResults: true,
                languageDetection: true,
              },
            })
            .then(({ data }) => {
              this.translation = data.translation[0];
              this.getImage(); //
            })
            .catch((err) => {
              this.$toast.error("خطا در ساخت کیو آر مجدد تلاش کنید");
              //   this.loading = false;
            })
            .finally(() => {
              //   this.loading = false;
            });
        }
      }
    },
    changeInput() {
      this.newCreate = false;
      this.loading = true;
      this.flag = true;
      let lang = this.langItems[this.selectedLang].value;

      if (lang === "fa") {
        // this.translateprompt(); //fa
        this.getImage(); //en
      } else {
        this.getImage(); //en
      }
    },
    header() {
      let token = localStorage.getItem("id_token");
      return {
        Authorization: token ? `Bearer ${token}` : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },
    getPackage() {
      axios
        .get(this.$aiApi + "/packages/user/package", {
          headers: this.header(),
        })
        .then((data) => {
          this.currentPackage = data.data.data;
          if (!this.currentPackage.remaining) {
            this.showUpgrade = true;
          }
        })

        .catch((response) => {
          console.error(response);
        })
        .finally(() => {});
    },
    async getImage() {
      this.loading = true;
      // this.getFreePackage();
      let needPack = !this.computedCurrentPackage.count;
      // let p =
      //   this.langItems[this.selectedLang].value === "fa"
      //     ? this.translation
      //     : this.prompt;
      // this.lastprompt = p;
      this.lastprompt = this.prompt;
      if (this.lastprompt.length > 65) {
        await axios
          .post(
            this.$aiApi + "/image/generate/qrcode",
            {
              link: this.link,
              prompt: this.lastprompt,
            },
            { headers: this.header() }
          )
          .then((data) => {
            // if (!data.data.data.success) {
            //   this.$modal.error(
            //     "خطا",
            //     "مشکل در سرور لطفا برای رفع مشکل با پشتیبانی تماس بگیرید."
            //   );
            //   this.loading = false;
            //   this.loading_Ai = false;

            //   return;
            // } //"message": "URL server validation failed"
            this.currentPackage = data.data.data.package;

            if (needPack && !data.data.data.package.remaining) {
              this.showUpgrade = true;
              this.$toast.info(rest.message || "خطا در ساخت کیوآر!");
            }

            if (!!data.data.data.request_id && !!data.data.data.nonce) {
              const intervalId = setInterval(() => {
                if (this.flag) {
                  axios
                    .post(
                      this.$aiApi + "/image/generate/qrcode/check",
                      {
                        request_id: data.data.data.request_id,
                        nonce: data.data.data.nonce,
                      },
                      { headers: this.header() }
                    )
                    .then((data2) => {
                      if (data2.data.data.status === "SUCCESS" && this.flag) {
                        this.flag = false;
                        this.loading = true;

                        if (data2.data.data.result_url) {
                          this.pngimg = data2.data.data.result_url;
                          this.isplaceholder = false;

                          this.scannable = data2.data.data.scannable === true;
                          this.saveImage();
                          // this.loading = false;
                          // setTimeout(() => {
                          //   this.prompt = this.initialPromptIdea;
                          // }, 10000);
                          clearInterval(intervalId);
                        }
                      }
                    })
                    .catch((error) => {
                      if (
                        // !data.data.data.success ||
                        error.response?.status === 400
                      ) {
                        this.$modal.error(
                          "خطا",
                          data.data.message ||
                            "مشکل در سرور لطفا برای رفع مشکل با پشتیبانی تماس بگیرید."
                        );
                        clearInterval(intervalId);
                        this.flag = true;
                        this.loading = false;
                        this.loading_Ai = false;
                        this.isplaceholder = true;
                        this.scannable = false;
                        this.pngimg = placeholder;
                        return;
                      } else {
                        clearInterval(intervalId);
                        this.flag = true;
                      }
                    })
                    .finally(() => {});
                }
              }, 11000);
            }
          })
          .catch((response) => {
            console.error(response, "response");

            if (response.response?.status === 400) {
              this.$modal.error(
                "خطا",
                "مشکل در سرور لطفا برای رفع مشکل با پشتیبانی تماس بگیرید."
              );
              this.loading = false;
              this.loading_Ai = false;

              return;
            } //"message": "URL server validation failed"
            //  this.loading = false;
          })
          .finally(() => {
            //  this.loading = false;
          });
      }
    },
    genetateTextForIdea(prompt, isRoost) {
      // if (prompt.length < 70 && isRoost) {
      //   this.$toast.error("متن ارسالی باید حداقل 70 کاراکتر باشد.");
      //   return;
      // }
      this.loading_Ai = true;
      if (!isRoost) {
        this.InitialpromptIdea = prompt;
      }
      if (prompt.length === 0) {
        this.$toast.error("متن وارد شده باید حداقل 3 کاراکتر باشد.");
        return;
      }
      this.showDialogIdea = false;
      let textMessage = `
یک متن فارسی و یک متن انگلیسی با حداقل 70 کاراکتر برای موضوع و تاکید بر ${prompt} که یک منظره طبیعی است تولید کنید و از جداکننده ||| برای جدا کردن متن فارسی و انگلیسی استفاده شود. متن‌ها باید توصیفی، بصری و غنی از جزئیات مانند رنگ‌ها، نور، عناصر طبیعی یا غیر طبیعی خیالی یا آینده نگر و خلاقانه  (مانند کوه، رودخانه، درختان، آسمان، شهر، جهان، کهکشان، ربات) و حال‌وهوای منظره باشند تا برای تولید تصویر جذاب توسط هوش مصنوعی مناسب باشند. فقط متن‌های فارسی و انگلیسی تولید شود، بدون توضیحات اضافی. جمله اضافه تر از متن درخواستی نوشته نشود. متن‌ها باید برای قرار گرفتن در QR کد (مانند منظره یا اثر بصری) مناسب و مختصر باشند.
`;
      let textRoostMessage = `
متن ورودی "${prompt}" که تاکید بر آن است را به دو متن فارسی و انگلیسی با حداقل 100 کاراکتر بازنویسی و تقویت کنید. از جداکننده ||| برای جداسازی متن فارسی و انگلیسی استفاده کنید. متن‌ها باید بسیار توصیفی، غنی از جزئیات بصری (مانند رنگ‌های زنده مثل طلایی غروب یا سبز زمردین، نورپردازی مانند پرتوهای خورشید یا مه صبحگاهی، و عناصر طبیعی و غیر طبیعی مثل کوه‌های بلند، رودخانه‌های خروشان، یا جنگل‌های انبوه، ماشین، خیابان های شهر) و دارای حال‌وهوای عاطفی (مانند آرامش‌بخش، اسرارآمیز یا الهام‌بخش) باشند. متن‌ها باید برای تولید تصویر خیره‌کننده توسط هوش مصنوعی بهینه و جذاب باشند و حس کنجکاوی و شگفتی را برانگیزند. از تکرار مستقیم متن ورودی پرهیز کنید و در عوض آن را خلاقانه بازنویسی کنید. فقط متن‌های فارسی و انگلیسی تولید شود، بدون توضیحات اضافی. جمله اضافه تر از متن درخواستی نوشته نشود..
`;

      //  this.prompt = prompt;
      this.$api
        .post(this.$aiApi + "/chat/tmp/chat", {
          model: "gpt-4o-mini",
          message: !isRoost ? textMessage : textRoostMessage,
        })
        .then(({ data }) => {
          let response = data.choices[0].message.content;
          [this.persianText, this.englishText] = response.split("|||");
          this.prompt =
            this.selectedLang === 0 ? this.persianText : this.englishText;
        })
        .catch((err) => {
          let message = isRoost
            ? "تقویت پرامپت با مشکل مواجه شد. لطفا مجدد تلاش کنید."
            : "ایجاد پرامپت با مشکل مواجه شد. لطفا مجدد تلاش کنید.";

          this.$modal.error("خطا", message);
          this.loading_Ai = false;
        })
        .finally(() => {
          this.loading_Ai = false;
        });
    },
    urlToBlob(url) {
      if (!url) {
        return Promise.reject(new Error("URL is empty or undefined"));
      }

      return fetch(url, {
        mode: "cors",
        headers: {
          Accept: "image/*",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.blob();
        })
        .catch((error) => {
          throw new Error(`Failed to convert URL to Blob: ${error.message}`);
        });
    },
    saveImage() {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = this.pngimg;
      const quality = 0.7;
      const maxWidth = 700;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const scale = Math.min(maxWidth / img.width, 1);
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const timestamp = Date.now();
              return saveOnCdnFiles(blob, `Qr_code_${timestamp}`, "Qrcode")
                .then((response) => {
                  this.$toast.success(
                    "تصویر ساخته شده با موفقیت در گالری  ذخیره شد!"
                  );
                })
                .catch((error) => {
                  this.$toast.error("خطای آپلود تصویر ساخته شده  به !");
                });
            } else {
              this.$toast.error("خطای تبدیل تصویر به !");
            }
          },
          "image/jpeg",
          quality
        );
      };
      img.onerror = () => {
        this.$toast.error("خطا در بارگذاری تصویر برای فشرده‌سازی!");
      };
      // this.urlToBlob(this.pngimg)
      //   .then((fileBlob) => {
      //     console.log(fileBlob, "filebolb");
      //     if (fileBlob) {
      //       const timestamp = Date.now();
      //       return saveOnCdnFiles(fileBlob, `Qr_code_${timestamp}`, "Qrcode")
      //         .then((response) => {
      //           console.log(`Qr_code_${timestamp}`, response, "response");
      //           this.$toast.success("تصویر با موفقیت در CDN ذخیره شد!");
      //         })
      //         .catch((error) => {
      //           console.error("Error saving to CDN:", error);
      //           this.$toast.error("خطای آپلود تصویر به CDN!");
      //         });
      //     } else {
      //       this.$toast.error("خطای تبدیل تصویر به Blob!");
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error converting to Blob:", error);
      //     this.$toast.error("خطای تبدیل تصویر!");
      //   })
      //   .finally(() => {});
    },
    showImg() {
      this.mediaDialog = true;

      this.$nextTick(() => {
        this.scale = 1;
      });
    },

    spellChecker(input) {
      const reg = {
        en: /[\u0600-\u06FF\u06F0-\u06F9]+/,
        fa: /[A-Za-z]+/,
      };
      return Array.from(input).every(
        (char) => !reg[this.computedSelectedLang.value].test(char)
      );
    },
    zoomIn() {
      this.scale += 0.1;
    },
    zoomOut() {
      if (this.scale > 0.2) this.scale -= 0.1;
    },
    resetZoom() {
      this.scale = 1;
    },
    compressImageAndDownload(
      fileurl,
      quality = 0.9,
      maxWidth = 800,
      filename = "qr_code_image.jpg"
    ) {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = fileurl;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const scale = Math.min(maxWidth / img.width, 1);
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = filename;
              document.body.appendChild(link);
              link.click();
              URL.revokeObjectURL(link.href);
              document.body.removeChild(link);
            }
          },
          "image/jpeg",
          quality
        );
      };
      img.onerror = () => {
        this.$toast.error("خطا در بارگذاری تصویر برای فشرده‌سازی!");
      };
    },
  },
};
</script>

<style scoped>
.cover {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.cursor-pointer:active,
.cursor-ponter:hover {
  scale: 1.2;
}
.cover-dialog {
  position: relative;
  display: flex;
  flex-direction: row;
  column-gap: 5px;
  width: 700px;
  height: 700px;
  overflow: hidden;
}
.zoom-controls {
  left: 5px;
  right: 5px;
  position: absolute;
  height: 50px;
  width: 150px;
  justify-content: center;
  align-items: center;
}
.btnZoom {
  font-size: 18px;

  flex: 0 0 auto;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  background-color: white;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.151),
    0px -4px 15px rgba(0, 0, 0, 0.151);
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
}
.btnZoom:hover,
.btnZoom:active {
  background-color: #f0f0f0;
  box-shadow: 0px 5px 17px rgba(0, 0, 0, 0.251),
    0px -5px 17px rgba(0, 0, 0, 0.251);
}
.conteiner-zoom {
  overflow: hidden;
}
.zoom-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  z-index: 10;
}
.popup {
  width: 700px !important;
  height: 770px !important;
  overflow: hidden;
}
.downloadbtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  gap: 2px;
  padding-top: 0px;
}
.v-textarea {
  position: relative !important;
  width: 100%;
}
:deep(.v-textarea .v-input__slot) {
  min-height: 120px !important;
  max-height: 200px !important;
  overflow-y: auto !important;
  padding-bottom: 50px !important;
}

:deep(.v-textarea .v-input__append-outer) {
  position: absolute !important;
  bottom: 10px !important;
  right: 10px !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
}

:deep(
    .pp
      .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
      > .v-input__control
      > .v-input__slot
  ) {
  margin-bottom: 0 !important;
}

.btn {
  margin-top: 0px;
  margin-right: 30px;
  width: auto;
}
:deep(
    .v-text-field--enclosed.v-input--dense:not(
        .v-text-field--solo
      ).v-text-field--outlined
      .v-input__append-inner
  ) {
  position: absolute !important;
  bottom: 10px !important;
  right: 10px !important;
}
</style>
